import { BASE_URL } from '../../config'

let option = { method: 'GET' }
let optionWithHeaders = (ClientID) => {
	return {
		method : 'GET',
		credentials: 'include',
		headers : { 
			'X-Client-ID' : ClientID,
			'Content-Type' : "application/json"
		}
	}
}

export default async (url, ClientID, cb) => {
	try {
		let res = await fetch(`${BASE_URL}${url}`, ClientID ? optionWithHeaders(ClientID) : option)
		let hasil = await res.json()
		if (res.status === 200) {
			cb(hasil.result, null)
		} else {
			cb(null, hasil.status.message)
		}
	} catch (err) {
		cb(null, err.message)
	}
}